export default {"src":"https://s.sylndr.com/c-c51c782/_next/static/media/greenTick.5b2711b8.svg","height":11,"width":16,"blurWidth":0,"blurHeight":0};